import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { DialogData } from 'src/app/quick-search/dialog/confirm-enable-screen-negative-payment.component';
import { IDownloadType } from 'src/app/shared/interfaces';

@Component({
  selector: 'app-download-parkers',
  templateUrl: './dialog-download-parkers.component.html',
  styleUrls: ['./dialog-download-parkers.component.scss'],
  standalone: true,
  imports: [MatDialogModule],
})
export class DialogDownloadParkersComponent {
  constructor(
    public dialogRef: MatDialogRef<DialogDownloadParkersComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IDownloadType,
  ) {
    data.downloadType = 0;
  }

  closeDialogNoAction(): void {
    this.dialogRef.close();
  }
}
